<template>
  <div class="products">
    <div>
      <i class="el-icon-s-order"></i>
      <h5>訂單内容</h5>
    </div>
    <h5>食物內容</h5>
    <div class="meal">
      <div>{{ meal.count || 1 }} x</div>
      <div>
        {{ meal.name }}
        <div v-for="(item, index) in meal.classify" :key="index">
          <p v-for="(el, key) in item.dishes" :key="key">
            -{{ el.count || 1 }}x {{ el.name }}
          </p>
        </div>
      </div>
      <div>
        ${{ (meal.price * (meal.count === 0 ? 1 : meal.count)).toFixed(2) }}
      </div>
    </div>
    <hr />
    <div class="coupon">
      <div>優惠碼 (如適用)</div>
      <div>
        <el-input size="mini"></el-input>
        <el-button size="mini">兌換</el-button>
      </div>
    </div>
    <hr />
    <h5
      v-if="
        way === 'self'
          ? additional.tableware !== 0 || additional.clamp !== 0
          : additional.tableware !== 0 || additional.clamp !== 0 || form.area
      "
    >
      額外收費
    </h5>
    <div class="coupon" v-if="additional.tableware !== 0">
      <div>額外餐具{{ additional.tableware }}份</div>
      <div>+ ${{ additional.tableware * additional.tablewarePrice }}</div>
    </div>
    <div class="coupon" v-if="additional.clamp !== 0">
      <div>額外食物夾{{ additional.clamp }}份</div>
      <div>+ ${{ additional.clamp * additional.clampPrice }}</div>
    </div>
    <div class="coupon" v-if="way !== 'self'">
      <div>{{ form.area ? form.area.split("[")[0] : null }}</div>
      <div>
        {{ form.area ? form.area.split("[")[1].split("]")[0] : null }}
      </div>
    </div>
    <hr
      v-if="
        way === 'self'
          ? additional.tableware !== 0 || additional.clamp !== 0
          : additional.tableware !== 0 || additional.clamp !== 0 || form.area
      "
    />
    <div class="total">
      <div>總價</div>
      <div>
        ${{
          (
            meal.price * (meal.count || 1) +
            (form.area
              ? parseInt(form.area.split("[")[1].split("]")[0].split("$")[1])
              : 0) +
            additional.tableware * additional.tablewarePrice +
            additional.clamp * additional.clampPrice
          ).toFixed(2) || meal.price
        }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["meal", "way", "form", "additional"],
  data() {
    return {
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.products {
  border: 1px solid hsla(0, 0%, 54.9%, 0.29);
  padding: 0.25rem 0.5rem;
}
.products > div {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: flex-start;
  padding: 0.25rem;
}
.products > h5,
.products > div > h5 {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 0;
}
.products > div > h5 {
  margin-left: 0.5rem;
}
.products > h5 {
  text-align: center;
  color: rgba(14, 14, 14, 0.701) !important;
  margin-bottom: 0.5rem;
}
.products > .meal {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.products > .meal > div:nth-child(2) > p {
  letter-spacing: 1px;
  font-size: 12px;
  margin: 0 0.2rem;
}
.products > hr {
  margin: 0.5rem 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.products > .coupon {
  display: flex;
  justify-content: space-between;
}
.products > .coupon > div {
  flex: 0 0 50%;
}
.products > .coupon > div:last-child {
  display: flex;
  justify-content: flex-end;
}
.products > .coupon > div:last-child >>> .el-input__inner {
  border-radius: 2px;
}
.products > .coupon > div:last-child >>> .el-button--mini {
  border-radius: 2px;
  background: linear-gradient(0deg, #ff9011, #fd9d20);
  color: #fff;
}

.products > .total {
  display: flex;
  justify-content: space-between;
}
.products > .total > div:last-child {
  font-weight: 700;
}
</style>
